import {
  emptyEntityFilters,
  type EntityCardView,
  type EntityLibraryFilters,
} from "@/types/entity";

export { emptyEntityFilters } from "@/types/entity";

export function hasActiveEntityFilters(filters: EntityLibraryFilters) {
  return (
    filters.searchText.trim().length > 0 || filters.typeFilter !== emptyEntityFilters.typeFilter
  );
}

export function applyEntityFilters(cards: EntityCardView[], filters: EntityLibraryFilters) {
  const normalizedSearch = filters.searchText.trim().toLowerCase();

  return [...cards]
    .filter((card) => {
      const matchesType = filters.typeFilter === "all" || card.type === filters.typeFilter;
      const matchesSearch =
        normalizedSearch.length === 0
        || card.name.toLowerCase().includes(normalizedSearch)
        || card.aliases.some((alias) => alias.toLowerCase().includes(normalizedSearch));

      return matchesType && matchesSearch;
    })
    .sort(
      (left, right) => new Date(right.updatedAt).getTime() - new Date(left.updatedAt).getTime(),
    );
}

export function getSelectedCardHiddenByFilters(
  visibleCards: EntityCardView[],
  activeEntityId: string | null,
  isCreatingCard: boolean,
) {
  if (!activeEntityId || isCreatingCard) {
    return false;
  }

  return !visibleCards.some((card) => card.id === activeEntityId);
}

export function getEntityLibraryResultSummary(
  filters: EntityLibraryFilters,
  resultCount: number,
  totalCount: number,
) {
  if (totalCount === 0) {
    return "No Entity Cards in this project yet.";
  }

  if (!hasActiveEntityFilters(filters)) {
    return `${resultCount} of ${totalCount} Entity Cards visible.`;
  }

  return `${resultCount} of ${totalCount} Entity Cards match the current library filters.`;
}
